import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const JournalDetail = (props: Props) => {
    return (
        <BooksDetail
            library_category={ELibraryCategory.MAGAZINE}
            library_head_name='วารสาร'
            library_head_pathname={routeName.e_library.journal}
            library_head_list_path={routeName.e_library.journal_list}
        />
    )
}

export default JournalDetail